import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Button from "../../../common/Button/Button";
import Select from "../../../common/Formik/Select/Select";
import Table from "../../../common/Table/Table";
import TransactionHistoryModal from "../../../common/Modals/TransactionHistoryModal/TransactionHistoryModal";
import BankDetailsModal from "../../../common/Modals/BankDetailsModal/BankDetailsModal";
import {
  addWireFundAction, getUserLedgerListAction, getWalletBalanceAction, getWalletHistoryAction, getCryptoBalanceAction, generateAccountAction,
  withdrawRequestAction, getFiatWithdrawListAction, cancelWithdrawRequestAction, getBankDetailsAction, getDepositHistoryAction, getWithdrawHistoryAction,
  getUserCoinListAction, generateWithdrawOTPAction, getPortfolioAction, getPendingDepositsAction, getCryptoPortfolioValueAction, getUserInfoAction,
  getTokenBalanceAction,
} from "../../../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDateTime, FORMIK_REGEX, Messages, STATUS_CODE } from "../../../../utils/constants";
import StripeCheckoutForm from "../../../common/Modals/CheckoutForm/StripeCheckoutForm";
import { STRIPE_PB_KEY } from "../../../../utils/constants";
import AddFunds from "../../../common/Modals/AddFunds/AddFunds";
import { formatDepositPrice, formatPrice, toFix } from "../../../../utils/utils";
import Commonpagination from "../../../common/Pagination/Commonpagination";
import PaymentModeModal from "../../../common/Modals/PaymentModeModal/PaymentModeModal";
import WithDrawModal from "../../../common/Modals/WithDrawModal/WithDrawModal";
import DepositModal from "../../../common/Modals/DepositModal/DepositModal";
import { useLocation } from "react-router-dom";
import { Col, Form, Nav, Row, Tab, Tabs } from "react-bootstrap";
import { replace } from "lodash";
import Slider from "react-slick";
import { toasts } from "../../../common/Toast/Toast";
import Radio from "../../../common/Formik/Radio/Radio";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import { useFormik } from "formik";
import * as Yup from "yup";
import { validationMessage } from "../../../../Helper/helperfunction";
import tradechartIcon from '../../../../assets/icons/tradechartIcon.svg';
import watchcircle from '../../../../assets/icons/watchcircle.svg';
import style from "./WalletPortfolio.module.scss";
import Deposit from "../CryptoWallet/DespositTransaction/Deposit/Deposit";
import Widthrow from "../CryptoWallet/DespositTransaction/Widthrow/Widthrow";
import Convert from "../CryptoWallet/DespositTransaction/Convert/Convert";
import WithdrawFiat from "./WithdrawFiat/WithdrawFiat";
import Tooltip from "../../../common/Tooltip/Tooltip";
import CopyBtn from "../../../common/CopyBtn/CopyBtn";

const WalletPortfolio = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const walletBalance = useSelector(
    (state) => state?.users?.commonWalletBalance.amount
  );
  const storeCoinId = useSelector((state) => state.users.selectedCoinId);
  const [cryptoBal, setCryptoBal] = useState("");
  const [selectedWallet, setSelectedWallet] = useState("");

  // === MINIMUM CHANGE: Replaced single page with separate states ===
  const [fiatWalletPage, setFiatWalletPage] = useState(1);
  const [fiatWithdrawRequestPage, setFiatWithdrawRequestPage] = useState(1);
  const [fiatWithdrawHistoryPage, setFiatWithdrawHistoryPage] = useState(1);
  const [cryptoDepositPage, setCryptoDepositPage] = useState(1);
  const [cryptoWithdrawPage, setCryptoWithdrawPage] = useState(1);
  // Add this line with your other useState declarations
  const [walletHistoryMeta, setWalletHistoryMeta] = useState({}); // ← NEW
  // ================================================================

  const size = 10;
  const [userLedger, setUserLedger] = useState([]);
  const [addFundModal, setAddFundModal] = useState(false);
  const [walletType, setWalletType] = useState("STRIPE");
  const [portfolioBalance, setPortfolioBalance] = useState(0);
  const [stripePayModal, setStripePayModal] = useState(false);
  const [stripeData, setStripeData] = useState({});
  const [payModeModal, setPayModeModal] = useState(false);
  const [withDrawModal, setWithDrawModal] = useState(false);
  const [depositModal, setDepositModal] = useState(false);
  const [withdrawList, setWithdrawList] = useState([]);
  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [requestPage, setRequestPage] = useState([]);
  const [historyPage, sethistoryPage] = useState([]);
  const [paymentMode, setPaymentMode] = useState("STRIPE");
  const [currentTab, setCurrentTab] = useState("Wallet History");
  const data = useLocation();
  const [mainTab, setMainTab] = useState(data?.state?.tab || "fiat");
  // const [selectedCoin, setSelectedCoin] = useState({});
  const [selectedNetwork, setSelectedNetwork] = useState({});
  const [networkOptions, setNetworkOptions] = useState([]);

  const [error, setError] = useState(null);
  const [bankDetail, setBankDetails] = useState([]);
  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(STRIPE_PB_KEY)
  );
  const [showBankDetailsModal, setShowBankDetailsModal] = useState(false);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [filter, setFilter] = useState({
    label: "ALL",
    value: "ALL",
    timeUnit: "All",
    count: 1,
  });
  const [paymentType, setPaymentType] = useState("stripe");
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpCooldown, setOtpCooldown] = useState(0);
  const [userData, setUserData] = useState(null);
  const [selectedCoin, setSelectedCoin] = useState(null);


  const [goldData, setGoldData] = useState();
  const [silverData, setSilverData] = useState();
  const [equityData, setEquityData] = useState();
  const [pendingDep, setPendingDep] = useState(0);
  const [cryptoPortfolioValue, setCryptoPortfolioValue] = useState(0);
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const equityPrice = useSelector((state) => state?.users?.equityPrice);

  useEffect(() => {
    if (data?.state?.tab) {
      setMainTab(data.state.tab);
    }
  }, [data?.state?.tab]);

  const timeOptions = [
    {
      label: "ALL",
      value: "ALL",
      timeUnit: "All",
      count: 1,
    },
    {
      label: "Success",
      value: "SUCCESS",
      timeUnit: "Success",
      count: 2,
    },
    {
      label: "Rejected",
      value: "REJECTED",
      timeUnit: "Rejected",
      count: 3,
    },
    {
      label: "Failed",
      value: "FAILED",
      timeUnit: "Failed",
      count: 4,
    },
    {
      label: "Pending",
      value: "PENDING",
      timeUnit: "Pending",
      count: 5,
    },
    {
      label: "Canceled",
      value: "CANCELED",
      timeUnit: "Cancelled",
      count: 6,
    },
  ];

  const getUserProfile = async () => {
    try {
      const response = await dispatch(getUserInfoAction());
      if (response?.data?.data) {
        setUserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setError("Failed to fetch user profile.");
    }
  };

  useEffect(() => {
    getUserProfile();
  }, []);

  const fetchCoinOptions = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        setCoinList(newData);
        newData?.forEach((coin) => {
          array.push({
            value: coin.id,
            label: coin.coin_symbol,
            networkdetails: coin.networkDetail,
            coinImage: coin.image_path,
          });
        });
        setCoinOptions(array);
        if (array.length > 0) {
          const defaultCoin = array[0];
          setSelectedCoin(defaultCoin);

          const defaultNetwork = defaultCoin.networkdetails[0];
          setSelectedNetwork({
            value: defaultNetwork.id,
            label: defaultNetwork.parent_coin_name,
          });
          setNetworkOptions(
            defaultCoin.networkdetails.map((network) => ({
              value: network.id,
              label: network.parent_coin_name,
            }))
          );
        }
      }
    } catch (error) {
      setError("Error fetching coin options.");
      console.error("Error fetching coin options:", error);
    } finally {
      setLoading(false);
    }
  };

  // === MINIMUM CHANGE: Updated to accept page parameter ===
  const withdrawHistoryCrypto = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await dispatch(
        getWithdrawHistoryAction({
          page: currentPage,
          limit: 5,
          coinId: storeCoinId,
        })
      );
      if (response.data.status === STATUS_CODE.successful) {
        setWithdrawData(response.data.data.data);
      }
    } catch (error) {
      setError("Error fetching withdraw history.");
      console.error("Error fetching withdraw history:", error);
    } finally {
      setLoading(false);
    }
  };

  // === MINIMUM CHANGE: Updated to accept page parameter ===
  const depositHistory = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await dispatch(
        getDepositHistoryAction({
          page: currentPage,
          limit: 5,
          coinId: storeCoinId,
        })
      );
      if (response.data.status === STATUS_CODE.successful) {
        setDepositData(response.data.data.data);
      }
    } catch (error) {
      setError("Error fetching deposit history.");
      console.error("Error fetching deposit history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Only run crypto-specific logic when in Crypto tab
    if (mainTab === "crypto") {
      getGoldSilverBalances(); // Gold/Silver STBL via /user/token/balance
      if (currentTab === "Deposit" && storeCoinId) {
        depositHistory(cryptoDepositPage);
      } else if (currentTab === "Withdraw" && storeCoinId) {
        withdrawHistoryCrypto(cryptoWithdrawPage);
      } else if (currentTab === "Allcoins") {
        fetchCoinOptions(); // Crypto coins via /wallet/user/coin_list
      }
    }
  }, [
    mainTab,
    currentTab,
    storeCoinId,
    dispatch,
    cryptoDepositPage,
    cryptoWithdrawPage,
  ]);

  const options = {
    mode: "payment",
    amount: 1000,
    currency: "usd",
    appearance: {
      /*...*/
    },
  };

  const getWalletBalance = async () => {
    try {
      const response = await dispatch(getWalletBalanceAction());
      if (response.status === 200) {
        setPortfolioBalance(response.data.data?.amount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCryptoBalance = async () => {
    try {
      const response = await dispatch(getCryptoBalanceAction());
      if (response.status === 200) {
        setCryptoBal(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // === MINIMUM CHANGE: Updated to accept page parameter ===
  const getUserLedgerList = async (currentPage = 1) => {
    try {
      const dataObj = {
        page: currentPage,
        size: size,
        sortByDate: "DESC",
      };
      const response = await dispatch(getWalletHistoryAction(dataObj));
      setUserLedger(response.data.data.list);
      setWalletHistoryMeta(response.data.data); // ← Save totalPages here
    } catch (error) {
      console.error("Error fetching wallet history:", error);
    }
  };



  useEffect(() => {
    getWalletBalance(); // Always safe (fiat balance)
    if (mainTab === "crypto") {
      fetchCoinOptions();
      getCryptoBalance(); // Only fetch crypto balances when in crypto tab
    }
  }, [mainTab, currentTab]);

  // Reset ALL pages to 1 whenever ANY tab changes
  useEffect(() => {
    setFiatWalletPage(1);
    setFiatWithdrawRequestPage(1);
    setFiatWithdrawHistoryPage(1);
    setCryptoDepositPage(1);
    setCryptoWithdrawPage(1);
  }, [currentTab, mainTab]);

  const handleAddFunds = async (dataObj) => {
    if (walletType === "STRIPE") {
      setStripeData(dataObj);
      setStripePayModal(true);
      setAddFundModal(false);
    } else {
      const response = await dispatch(addWireFundAction(dataObj));
      if (response.status === 200) {
        setAddFundModal(false);
      }
    }
  };



  useEffect(() => {
    getBankDetails();
  }, []);

  // Countdown effect for OTP cooldown
  useEffect(() => {
    if (otpCooldown > 0) {
      const timer = setTimeout(() => setOtpCooldown(otpCooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [otpCooldown]);

  const getBankDetails = async () => {
    try {
      const response = await dispatch(getBankDetailsAction());
      if (response?.status === 200) {
        const details = response.data.data;
        setBankDetails(details);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const openWithdrawModal = () => {
    if (bankDetail && Object.keys(bankDetail).length > 0) {
      setWithDrawModal(true);
    } else {
      toasts.error("Please add your Bank details in My Profile settings.");
    }
  };

  const handleWithdraw = async () => {
    try {
      const generateAccountResponse = await dispatch(generateAccountAction());
      if (generateAccountResponse.status === 200) {
        const withdrawRequestResponse = await dispatch(withdrawRequestAction());
        if (withdrawRequestResponse.status === 200) {
          await fetchFiatWithdrawList();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // === MINIMUM CHANGE: Updated to accept page parameter ===
  const fetchFiatWithdrawList = async (currentPage = 1) => {
    try {
      const response = await dispatch(
        getFiatWithdrawListAction({
          page: currentPage,
          size: size,
          transactionStatus: "PENDING",
        })
      );
      if (response.data.status === 200) {
        setRequestPage(response.data.data);
        setWithdrawList(response.data.data.list);
      }
    } catch (error) {
      // console.error("Error fetching withdraw list:", error);
    } finally {
      setLoading(false);
    }
  };

  // === MINIMUM CHANGE: Updated to accept page parameter ===
  const fetchFiatWithdrawHistory = async (currentPage = 1) => {
    try {
      const response = await dispatch(
        getFiatWithdrawListAction({
          page: currentPage,
          size: size,
          transactionStatus: filter.value,
        })
      );
      if (response.data.status === 200) {
        sethistoryPage(response.data.data);
        setWithdrawHistory(response.data.data.list);
      }
    } catch (error) {
      console.error("Error fetching withdraw list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentModeSubmit = () => {
    setPayModeModal(false);
    setAddFundModal(true);
  };

  const handleDepositModal = () => {
    setDepositModal(true);
  };


  const filterCoins = () => {
    if (currentTab === "Withdraw Request") {
      return withdrawList;
    } else if (currentTab === "Withdraw History") {
      // Ensure withdrawHistory is an array before filtering
      const history = Array.isArray(withdrawHistory) ? withdrawHistory : [];
      return history.filter(
        (item) =>
          item.transaction_status === filter.value || filter.value === "ALL"
      );
    } else {
      return userLedger;
    }
  };

  const getFieldsByTab = () => {
    if (currentTab === "Wallet History") {
      return [
        { label: "Txn ID", key: "transaction_id" },
        { label: "Amount (USD STBL)", key: "amount" },
        { label: "Txn Action", key: "transaction_type" },
        { label: "Txn Created From", key: "transaction_order_type" },
        { label: "Transaction Status", key: "transaction_status" },
        { label: "Date&Time", key: "created_at" },
      ];
    } else if (currentTab === "Withdraw Request") {
      return [
        { label: "Request ID", key: "account_uuid" },
        { label: "Username", key: "username" },
        { label: "Amount", key: "amount" },
        { label: "Request Method", key: "requested_method" },
        { label: "Date&Time", key: "created_at" },
        { label: "Bank Details", key: "bankDetails" },
        { label: "Action", key: "action" },

      ];
    } else if (currentTab === "Withdraw History") {
      return [
        { label: "Username", key: "username" },
        { label: "Amount", key: "amount" },
        { label: "Request Method", key: "requested_method" },
        { label: "Status", key: "status" },
        { label: "Bank Details", key: "bankDetails" },
        { label: "Transaction Type", key: "transaction_type" },
        { label: "Date&Time", key: "created_at" },
      ];
    } else {
      return [];
    }
  };

  const handleCancelRequest = async (item) => {
    try {
      // Assuming you have an action to cancel a withdraw request
      const response = await dispatch(
        cancelWithdrawRequestAction({
          requestId: item.account_uuid,
        })
      );
      if (response.status === 200) {
        // Refresh the withdraw list
        fetchFiatWithdrawList();
      }
    } catch (error) {
      console.error("Error cancelling withdraw request:", error);
    }
  };

  const handleBankDetails = (details) => {
    setSelectedBankDetails(details.user_bank_detail);
    setShowBankDetailsModal(true);
  };

  const fields = getFieldsByTab();

  const handleTabSelect = (e) => {
    setCurrentTab(e?.replace("_", " "));
  };

  // const formik = useFormik({
  //   enableReinitialize: true,
  //   initialValues: {
  //     amount: "",
  //     transactionID: "",
  //   },
  //   validationSchema: validationSchema,
  //   onSubmit: async () => {},
  // });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: "",
      transactionID: "",
    },
    validationSchema: Yup.object({
      amount: Yup.string()
        .required("Required")
        .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION)
        .test("is-decimal", "Two decimal places allowed", (val) => {
          if (val !== undefined) {
            return FORMIK_REGEX.TWODECIMALNUMBER.test(val);
          }
          return true;
        })
        .test("stripe-max", "Amount cannot exceed $999,999.99 for card payments", (val) => {
          if (paymentType === "stripe" && val !== undefined) {
            return Number(val) <= 999999.99;
          }
          return true;
        })
        .test(
          "wire-amount-range",
          "Amount must be between $100 and $5000",
          (val) => {
            if (paymentType !== "wire") return true;
            if (val === undefined || val === "") return true;

            const num = Number(val);
            return num >= 100 && num <= 5000;
          }
        ),
      // amount: Yup.string().required(validationMessage("Amount")),
      ...(paymentType === "wire" && {
        transactionID: Yup.string().required(
          validationMessage("Transaction ID")
        ),
      }),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      if (paymentType === "stripe") {
        // setStripeData({ amount: values.amount });
        setStripeData({
          user_id: userData?.id,
          user_uid: userData?.user_uid,
          amount: Math.round(Number(formik.values.amount) * 100),
          totalAmount: Math.round(Number(formik.values.amount) * 100),
          orderCreatedFrom: "STRIPE_VIRTUAL_WALLET",
        });
        setStripePayModal(true);
      } else if (paymentType === "wire") {
        try {
          const response = await dispatch(
            addWireFundAction({
              amount: values.amount,
              transaction_id: values.transactionID,
            })
          );

          if (response?.status === 200) {
            resetForm();
            getWalletBalance();
          }
        } catch (error) {
          console.error("Wire deposit error:", error);
        }
      }
      setSubmitting(false);
    },
  });

  const handlePaymentTypeSelect = (type) => {
    if (type === paymentType) return;
    formik.resetForm();
    setPaymentType(type);
  };

  const settings = {
    dots: false,
    infinite: false,
    arrow: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 407,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const settingscrypto = {
    dots: false,
    infinite: false,
    arrow: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrow: true,
        },
      },
      {
        breakpoint: 355,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrow: true,
        },
      },
    ],
  };
  // ---------- SAFE NUMBER HELPERS ----------
  const safeNum = (val) => Number(val ?? 0);
  const safeMul = (a, b) => safeNum(a) * safeNum(b);

  // ---------- SAFE QUANTITY HELPER ----------
  const parseTokenQty = (qty) =>
    Array.isArray(qty) && qty.length === 0 ? 0 : qty ?? 0;

  // ---------- API CALL ----------
  // Gold & Silver STBL balances from GET /user/token/balance
  const getGoldSilverBalances = async () => {
    try {
      const goldBalanceRes = await dispatch(getTokenBalanceAction({ tokenId: 1 }));
      const silverBalanceRes = await dispatch(getTokenBalanceAction({ tokenId: 2 }));

      setGoldData({
        tokenBalance: parseTokenQty(goldBalanceRes?.data?.data?.quantity),
      });
      setSilverData({
        tokenBalance: parseTokenQty(silverBalanceRes?.data?.data?.quantity),
      });
    } catch (error) {
      console.log("Error fetching gold/silver token balance", error);
    }
  };

  // Equity (and fallback portfolio data) from portfolio-balance API
  const getPortfolioData = async () => {
    try {
      const params = { dateFilterVal: "WEEK" };
      const res = await dispatch(getPortfolioAction(params));
      if (res.status === 200) {
        const data = res?.data?.data ?? [];
        setEquityData(data.find((item) => item.name === "Equity"));
      }
    } catch (error) {
      console.log("Error fetching portfolio");
    }
  };

  useEffect(() => {
    getGoldSilverBalances();
    getPortfolioData();
    getPendingDeposits();
    getCryptoPortfolioValue();
  }, []);

  // ********** FOR PENDING DEPOSITS API ********** 
  const getPendingDeposits = async () => {
    try {
      const res = await dispatch(getPendingDepositsAction());
      if (res?.data?.status === 200) {
        setPendingDep(res?.data?.data || 0);
      } else {
        setPendingDep(0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  // ********** FOR CRYPTO PORTFOLIO VALUE API ********** 
  const getCryptoPortfolioValue = async () => {
    try {
      const res = await dispatch(getCryptoPortfolioValueAction());
      if (res?.data?.status === 200) {
        setCryptoPortfolioValue(res?.data?.data || 0);
      } else {
        setCryptoPortfolioValue(0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  // ---------- CALCULATIONS ----------
  const goldBalance = safeMul(goldData?.tokenBalance, spotPrice?.goldPrice);
  const silverBalance = safeMul(silverData?.tokenBalance, spotPrice?.silverPrice);
  const equityBalance = safeMul(equityData?.tokenBalance, equityPrice?.price);

  const portfolioBal = goldBalance + silverBalance + equityBalance;

  const transactioncard = [
    { classcard: '', iconcard: tradechartIcon, label: 'Portfolio value', values: formatPrice(walletBalance), coinname: 'USD STBL', },
    { classcard: 'light_green', iconcard: watchcircle, label: 'Pending deposits', values: `$${formatPrice(pendingDep)}`, },
    // { classcard: 'light_blue', iconcard: paichartIcon, label: 'Reserved for orders', values: '$5,000.00', },
  ];
  const cryptotransactioncard = [
    { classcard: '', iconcard: tradechartIcon, label: 'Portfolio value', values: formatPrice(cryptoPortfolioValue), coinname: 'USD STBL', },
    { classcard: 'light_green amountadd', iconcard: tradechartIcon, label: 'Gold STBL', values: `${formatPrice(goldData?.tokenBalance)} GSTBL`, amountvalue: `$${formatPrice(goldBalance)}`, },
    { classcard: 'light_blue amountadd', iconcard: watchcircle, label: 'Silver STBL', values: `${formatPrice(silverData?.tokenBalance)} SSTBL`, amountvalue: `$${formatPrice(silverBalance)}`, },
  ];

  const [coinLists, setCoinList] = useState([]);
  const [coinOptions, setCoinOptions] = useState([]);
  const [depositData, setDepositData] = useState([]);
  const [withdrawData, setWithdrawData] = useState([]);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const formatCoin = (id) => {
    const defaultCoin = coinOptions?.find((coin) => coin.label === "BTC");
    if (!id)
      return defaultCoin ? (
        <div className={style.coin}>
          <img
            src={defaultCoin.coinImage}
            alt={defaultCoin.label}
            className={style.coinImage}
          />
          <span>{defaultCoin.label}</span>
        </div>
      ) : (
        "BTC"
      );

    const coin = coinOptions?.find((coin) => coin.value === id);
    return coin ? (
      <div className={style.coin}>
        <img
          src={coin.coinImage}
          alt={coin.label}
          className={style.coinImage}
        />
        <span>{coin.label}</span>
      </div>
    ) : defaultCoin ? (
      <div className={style.coin}>
        <img
          src={defaultCoin.coinImage}
          alt={defaultCoin.label}
          className={style.coinImage}
        />
        {defaultCoin.label}
      </div>
    ) : (
      "Unknown Coin"
    );
  };
  const formatTransactionId = (id) => {
    if (!id) return "-";
    if (id.length <= 10) return id;
    return `${id.slice(0, 5)}...${id.slice(-5)}`;
  };

  const getFieldsByTabcrypto = () => {
    if (currentTab === "Deposit") {
      return [
        { label: "Coin Name", key: "coin_name" },
        { label: "Transaction ID", key: "transaction_id" },
        { label: "Amount", key: "amount" },
        { label: "Status", key: "status" },
        { label: "Transaction Type", key: "transaction_type" },
      ];
    } else if (currentTab === "Withdraw") {
      return [
        { label: "Coin Name", key: "coin_name" },
        { label: "Transaction ID", key: "transaction_id" },
        { label: "Amount", key: "amount" },
        { label: "Status", key: "status" },
        { label: "Transaction Type", key: "transaction_type" },
      ];
    } else {
      return [
        { label: "Coin Name", key: "coin_name" },
        { label: "Price", key: "coinPrice" },
        { label: "My Balance", key: "balance" },
        { label: "In Order", key: "locked_balance" },
      ];
    }
  };
  const formatTransactionType = (type) => {
    switch (type) {
      case 1:
        return "Internal";
      case 2:
        return "External";
      default:
        return type;
    }
  };
  const formatDepositStatus = (status) => {
    switch (status) {
      case 1:
      case 6:
        return "Completed";
      case 0:
        return "Pending";
      case 2:
        return "Completed";
      case 3:
        return "Completed";
      case 4:
        return "Completed";
      case 5:
        return "Error while Moved to Central Wallet";
      default:
        return "Unknown Status";
    }
  };
  const formatStatus = (status) => {
    if (currentTab === "Deposit") {
      return formatDepositStatus(status);
    }
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "In Progress";
      case 3:
        return "Rejected";
      case 5:
        return "Cancelled";
      case 6:
        return "Confirmed";
      default:
        return "In Progress";
    }
  };
  const fieldscrypto = getFieldsByTabcrypto();

  const handleGenerateOtp = async () => {
    setOtpLoading(true);
    try {
      const response = await dispatch(
        generateWithdrawOTPAction({
          type: "EMAIL",
          service: "WITHDRAW_REQUEST",
          username: userData?.email,
        })
      );

      if (response.data.status === STATUS_CODE.successful) {
        setOtp(response.data.data.otp);
        setOtpCooldown(60); // Start 60 seconds cooldown
      }
    } catch (error) {
      console.error("Error generating OTP:", error);
      toasts.error("Failed to generate OTP.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleAmountChange = (e) => {
    const input = e.target.value;
    const filteredInput = input.replace(/[^0-9.]/g, "");
    const value = filteredInput;
    const regex = new RegExp(
      `^\\d*(\\.\\d{0,${decimalLimit[selectedCoin?.label]}})?$`
    );
    if (value === "" || regex.test(value)) {
      formik.setFieldValue("withdrawAmount", value);
    }
  };
  const widthdrwadata = [
    { label: " Bank Name", value: "SBI" },
    { label: "Account Number", value: "132121531" },
    { label: "Routing Number", value: "121321" },
    { label: "Bank Address", value: "7a0cf....771fe" },
  ];

  // === MINIMUM CHANGE: Updated useEffect with separate pagination ===
  useEffect(() => {
    if (mainTab === "fiat") {
      if (currentTab === "Wallet History") {
        getUserLedgerList(fiatWalletPage);
      } else if (currentTab === "Withdraw Request") {
        fetchFiatWithdrawList(fiatWithdrawRequestPage);
      } else if (currentTab === "Withdraw History") {
        fetchFiatWithdrawHistory(fiatWithdrawHistoryPage);
      }
    }
  }, [
    mainTab,
    currentTab,
    filter,
    fiatWalletPage,
    fiatWithdrawRequestPage,
    fiatWithdrawHistoryPage,
  ]);

  return (
    <>
      <section className={style.walletPortfolio}>
        <Tabs
          activeKey={mainTab}
          id="uncontrolled-tab-example"
          className="tab_black"
          onSelect={(k) => setMainTab(k)}
        >
          <Tab eventKey="fiat" title="Fiat">
            <div className={style.walletPortfolio_topCards}>
              <Row>
                {transactioncard.map((items, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="card_col">
                    <div
                      className={`${style.cardtransaction} ${items.classcard}`}
                    >
                      <div className={style.icon_track}>
                        <img src={items.iconcard} alt="icons" />
                      </div>
                      <div className={style.text_sec}>
                        <label>{items.label}</label>
                        <h4 className="big">
                          {items.values}
                          {items.coinname && <span>{items.coinname}</span>}
                        </h4>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className={style.walletPortfolio_fiatdata}>
              <Row>
                <Col xl={8} lg={7} className={`colcom ${style.colleft}`}>
                  <div className={style.walletTable}>
                    <Tab.Container
                      onSelect={handleTabSelect}
                      id="left-tabs-example"
                      defaultActiveKey="Wallet_History"
                    >
                      <div
                        className={`common_tablist ${currentTab === "Withdraw History" ? "selectShow" : ""
                          }`}
                      >
                        {currentTab === "Withdraw History" && (
                          <Select
                            isSearchable={false}
                            options={timeOptions}
                            placeholder={<h5>Success</h5>}
                            className={style.select_time}
                            onChange={(selected) => setFilter(selected)}
                            defaultValue={timeOptions[0]}
                          />
                        )}
                        <Nav variant="pills" className="navlist">
                          <Slider {...settings}>
                            <Nav.Item>
                              <Nav.Link eventKey="Wallet_History">
                                <span>Wallet History</span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Withdraw_Request">
                                <span>Withdraw Request</span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Withdraw_History">
                                <span>Withdraw History</span>
                              </Nav.Link>
                            </Nav.Item>
                          </Slider>
                        </Nav>
                      </div>
                      <div className="tab_data">
                        <Tab.Content>
                          <Tab.Pane eventKey="Wallet_History">
                            <Table
                              noRecordContent={"No records were found."}
                              noRecordClassName={style.no_content}
                              noContentVariant="large"
                              fields={fields}
                              loadingClassName={"loading_table"}
                              className={style.table}
                            >
                              {filterCoins().length > 0 ? (
                                filterCoins().map((item, index) => (
                                  <tr key={index}>
                                    <td>   <Tooltip
                                      icon={<span>{item?.transaction_id}</span>}
                                      content={
                                        <>
                                          <CopyBtn text={item?.transaction_id} /> {item?.transaction_id}
                                        </>
                                      }
                                    /></td>

                                    <td>{formatPrice(Number(item?.amount))}</td>
                                    <td>{item?.transaction_type}</td>
                                    <td>{item?.transaction_order_type}</td>
                                    <td>{item?.transaction_status}</td>
                                    <td>{formatDateTime(item?.created_at)}</td>
                                  </tr>
                                ))
                              ) : (

                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan={fields.length}
                                  >
                                    No records found!
                                  </td>
                                </tr>
                              )}
                            </Table>
                            {/* === MINIMUM CHANGE: Updated pagination for Wallet History === */}
                            {/* === FIXED: Wallet History Pagination === */}
                            {walletHistoryMeta?.totalItems > size && (
                              <Commonpagination
                                pagination
                                currentPage={fiatWalletPage}
                                className={style.pagination}
                                pageSize={size}
                                totalPages={walletHistoryMeta?.totalPages}
                                handlePageChange={(selected) =>
                                  setFiatWalletPage(selected)
                                }
                              />
                            )}
                          </Tab.Pane>
                          <Tab.Pane eventKey="Withdraw_Request">
                            <Table
                              noRecordContent={"No records were found."}
                              noRecordClassName={style.no_content}
                              noContentVariant="large"
                              fields={fields}
                              loadingClassName={"loading_table"}
                              className={style.table}
                            >
                              {filterCoins().length > 0 ? (
                                filterCoins().map((item, index) => (
                                  <tr key={index}>

                                    <td>   <Tooltip
                                      icon={<span>{item?.account_uuid}</span>}
                                      content={
                                        <>
                                          <CopyBtn text={item?.account_uuid} /> {item?.account_uuid}
                                        </>
                                      }
                                    /></td>
                                    <td>{item?.user?.username}</td>
                                    <td>{formatPrice(item?.amount)}</td>
                                    <td>{item?.requested_method}</td>
                                    <td>{formatDateTime(item?.created_at)}</td>
                                    <td>
                                      <Button
                                        onClick={() => handleBankDetails(item)}
                                      >
                                        Details
                                      </Button>
                                    </td>
                                    <td>
                                      <Button
                                        onClick={() =>
                                          handleCancelRequest(item)
                                        }
                                      >
                                        Cancel
                                      </Button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan={fields.length}
                                  >
                                    No records found!
                                  </td>
                                </tr>
                              )}
                            </Table>
                            {/* === MINIMUM CHANGE: Updated pagination for Withdraw Request === */}
                            {/* === Withdraw Request Pagination (correct) === */}
                            {requestPage?.totalItems > size && (
                              <Commonpagination
                                pagination
                                currentPage={fiatWithdrawRequestPage}
                                className={style.pagination}
                                pageSize={size}
                                totalPages={requestPage?.totalPages}
                                handlePageChange={(selected) =>
                                  setFiatWithdrawRequestPage(selected)
                                }
                              />
                            )}
                          </Tab.Pane>
                          <Tab.Pane eventKey="Withdraw_History">
                            <Table
                              noRecordContent={"No records were found."}
                              noRecordClassName={style.no_content}
                              noContentVariant="large"
                              fields={fields}
                              loadingClassName={"loading_table"}
                              className={style.table}
                            >
                              {filterCoins().length > 0 ? (
                                filterCoins().map((item, index) => (
                                  <tr key={index}>
                                    {/* <td>{item?.user_id}</td> */}
                                    <td>{item?.user?.username}</td>
                                    <td>{formatPrice(item?.amount)}</td>
                                    <td>{item?.requested_method}</td>
                                    <td>{item?.transaction_status}</td>
                                    <td>
                                      <Button
                                        onClick={() => handleBankDetails(item)}
                                      >
                                        Details
                                      </Button>
                                    </td>
                                    <td>{item?.transaction_type}</td>
                                    <td>{formatDateTime(item?.created_at)}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan={fields.length}
                                  >
                                    No records found!
                                  </td>
                                </tr>
                              )}
                            </Table>
                            {/* === MINIMUM CHANGE: Updated pagination for Withdraw History === */}
                            {/* === Withdraw History Pagination (correct) === */}
                            {historyPage?.totalItems > size && (
                              <Commonpagination
                                pagination
                                currentPage={fiatWithdrawHistoryPage}
                                className={style.pagination}
                                pageSize={size}
                                totalPages={historyPage?.totalPages}
                                handlePageChange={(selected) =>
                                  setFiatWithdrawHistoryPage(selected)
                                }
                              />
                            )}
                          </Tab.Pane>
                        </Tab.Content>
                      </div>
                    </Tab.Container>
                  </div>
                </Col>
                <Col xl={4} lg={5} className={`colcom ${style.colright}`}>
                  <div className={style.walletleftaddfunds}>
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey={
                        data?.state?.type === "withdraw"
                          ? "withdrawals"
                          : "deposits"
                      }
                      className="tabContainer"
                    >
                      <div className="tabHeader">
                        <Nav variant="pills" className="navTabs">
                          {/* <Slider {...settings}> */}
                          <Nav.Item>
                            <Nav.Link eventKey="deposits">Deposits</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="withdrawals">
                              Withdrawals
                            </Nav.Link>
                          </Nav.Item>
                          {/* </Slider> */}
                        </Nav>
                      </div>
                      <Tab.Content>
                        <Tab.Pane eventKey="deposits">
                          <div className={style.depositTab}>
                            <ul className={style.depositList}>
                              <li onClick={() => handlePaymentTypeSelect("stripe")}>
                                <Radio
                                  checked={paymentType === "stripe"}
                                  onChange={() => handlePaymentTypeSelect("stripe")}
                                  className="radiobtn"
                                >
                                  <div className="radioText">
                                    <h6>Stripe Payment</h6>
                                    <p>
                                      3% fees will be charged for Stripe payment
                                    </p>
                                  </div>
                                </Radio>
                              </li>
                              <li onClick={() => handlePaymentTypeSelect("wire")}>
                                <Radio
                                  checked={paymentType === "wire"}
                                  onChange={() => handlePaymentTypeSelect("wire")}
                                  className="radiobtn"
                                >
                                  <div className="radioText">
                                    <h6>Wire Payment</h6>
                                  </div>
                                </Radio>
                              </li>
                            </ul>
                            <div className={style.forminput}>
                              <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                {paymentType === "wire" && (
                                  <InputFormik
                                    variant="large_height"
                                    name="transactionID"
                                    label="Transaction ID"
                                    control="input"
                                    type="text"
                                    className={style.input}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder="Please enter transaction ID"
                                    formik={formik}
                                    maxLength={30}
                                    value={formik.values.transactionID}
                                  />
                                )}
                                <InputFormik
                                  variant="large_height"
                                  name="amount"
                                  label="Amount"
                                  control="input"
                                  type="text"
                                  value={formik.values.amount}
                                  className={style.input}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  placeholder="Please enter amount"
                                  formik={formik}
                                  maxLength={30}
                                />
                                <Button
                                  fluid
                                  className={style.addfund_btn}
                                  type="button"
                                  disabled={
                                    formik.isSubmitting || !formik.isValid
                                  }
                                  onClick={(e) => {
                                    formik.handleSubmit(e);
                                  }}
                                >
                                  Add Funds
                                </Button>
                              </form>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="withdrawals">

                          <WithdrawFiat portfolioBalance={portfolioBalance} />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </Col>
              </Row>
            </div>
          </Tab>
          <Tab eventKey="crypto" title="Crypto">
            <div className={style.walletPortfolio_topCards}>
              <Row>
                {cryptotransactioncard.map((items, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="card_col">
                    <div
                      className={`${style.cardtransaction} ${items.classcard}`}
                    >
                      <div className={style.leftCard}>
                        <div className={style.icon_track}>
                          <img src={items.iconcard} alt="icons" />
                        </div>
                        <div className={style.text_sec}>
                          <label>{items.label}</label>
                          <h4 className="big">
                            {items.values}
                            {items.coinname && <span>{items.coinname}</span>}
                          </h4>
                        </div>
                      </div>
                      {items.amountvalue && (
                        <div className={style.right_text}>
                          <h4>{items.amountvalue}</h4>
                        </div>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className={style.walletPortfolio_fiatdata}>
              <Row>
                <Col xl={8} lg={7} className={style.colleft}>
                  <div className={style.walletTable}>
                    <Tab.Container
                      onSelect={handleTabSelect}
                      id="left-tabs-example"
                      defaultActiveKey="Allcoins"
                    >
                      <div className={`common_tablist tabhead_crypto `}>
                        <div className="heading">
                          <h4>Transaction History</h4>
                        </div>
                        <Nav variant="pills" className="navlist">
                          <Slider {...settingscrypto}>
                            <Nav.Item>
                              <Nav.Link eventKey="Allcoins">
                                <span>All Coins</span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Deposit">
                                <span>Deposit</span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Withdraw">
                                <span>Withdraw</span>
                              </Nav.Link>
                            </Nav.Item>
                          </Slider>
                        </Nav>
                      </div>
                      <div className="tab_data">
                        <Tab.Content>
                          {/* *************************** ALL COINS TAB *************************** */}
                          <Tab.Pane eventKey="Allcoins">
                            <Table
                              noRecordContent={"No records were found."}
                              noRecordClassName={style.no_content}
                              noContentVariant="large"
                              fields={fieldscrypto}
                              loadingClassName={"loading_table"}
                              className={style.table}
                            >
                              {coinLists?.length > 0 ? (
                                coinLists?.map((item) => (
                                  <tr key={item.id}>
                                    <td>{formatCoin(item?.id)}</td>
                                    <td>${formatPrice(item?.coinPrice)}</td>
                                    <td>
                                      {item?.balance != 0
                                        ? toFix(
                                          item?.balance,
                                          decimalLimit[item?.coin_symbol]
                                        )
                                        : 0}
                                    </td>
                                    <td>
                                      {item?.locked_balance != 0
                                        ? toFix(
                                          item?.locked_balance,
                                          decimalLimit[item?.coin_symbol]
                                        )
                                        : 0}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan={fieldscrypto.length}
                                  >
                                    No records found!
                                  </td>
                                </tr>
                              )}
                            </Table>
                          </Tab.Pane>
                          {/* *************************** DEPOSIT TAB *************************** */}
                          <Tab.Pane eventKey="Deposit">
                            <Table
                              noRecordContent={"No records were found."}
                              noRecordClassName={style.no_content}
                              noContentVariant="large"
                              fields={fieldscrypto}
                              loadingClassName={"loading_table"}
                              className={style.table}
                            >
                              {depositData?.depositlist?.length > 0 ? (
                                depositData?.depositlist?.map((item) => (
                                  <tr key={item.transaction_id}>
                                    <td>{formatCoin(item?.coin_id)}</td>

                                    <td>   <Tooltip
                                      icon={<span>{formatTransactionId(
                                        item?.transaction_id
                                      )}</span>}
                                      content={
                                        <>
                                          <CopyBtn text={(
                                            item?.transaction_id
                                          )} /> {(
                                            item?.transaction_id
                                          )}
                                        </>
                                      }
                                    /></td>
                                    <td>{formatDepositPrice(item?.amount)}</td>
                                    {/* <td>
                                                  {formatPrice(item?.amount).replace(
                                                    /(\.\d{2})$/,
                                                    (match) => match + "000"
                                                  )}
                                                </td> */}
                                    <td>{formatStatus(item?.status)}</td>
                                    <td>
                                      {formatTransactionType(
                                        item?.transaction_type
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan={fieldscrypto.length}
                                  >
                                    No records found!
                                  </td>
                                </tr>
                              )}
                            </Table>
                            {/* === MINIMUM CHANGE: Updated pagination for Crypto Deposit === */}
                            {depositData?.totalPages > 1 && (
                              <Commonpagination
                                pagination
                                currentPage={cryptoDepositPage}
                                className={style.pagination}
                                pageSize={size}
                                totalPages={depositData?.totalPages}
                                handlePageChange={(selected) =>
                                  setCryptoDepositPage(selected)
                                }
                              />
                            )}
                          </Tab.Pane>
                          {/* *************************** WITHDRAW TAB *************************** */}
                          <Tab.Pane eventKey="Withdraw">
                            <Table
                              noRecordContent={"No records were found."}
                              noRecordClassName={style.no_content}
                              noContentVariant="large"
                              fields={fieldscrypto}
                              loadingClassName={"loading_table"}
                              className={style.table}
                            >
                              {withdrawData?.withdrawlist?.length > 0 ? (
                                withdrawData?.withdrawlist?.map((item) => (
                                  <tr key={item.transaction_id}>
                                    <td>{formatCoin(item?.coin_id)}</td>
                                    <td>
                                      <Tooltip
                                        icon={
                                          <span>
                                            {formatTransactionId(
                                              item?.transaction_id
                                            )}
                                          </span>
                                        }
                                        content={
                                          <>
                                            <CopyBtn
                                              text={item?.transaction_id}
                                            />{" "}
                                            {item?.transaction_id}
                                          </>
                                        }
                                      />
                                    </td>
                                    <td>{formatDepositPrice(item?.amount)}</td>

                                    <td>{formatStatus(item?.status)}</td>
                                    <td>
                                      {formatTransactionType(
                                        item?.transaction_type
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan={fieldscrypto?.length}
                                  >
                                    No records found!
                                  </td>
                                </tr>
                              )}
                            </Table>
                            {/* === MINIMUM CHANGE: Updated pagination for Crypto Withdraw === */}
                            {withdrawData?.totalPages > 1 && (
                              <Commonpagination
                                pagination
                                currentPage={cryptoWithdrawPage}
                                className={style.pagination}
                                pageSize={size}
                                totalPages={withdrawData?.totalPages}
                                handlePageChange={(selected) =>
                                  setCryptoWithdrawPage(selected)
                                }
                              />
                            )}
                          </Tab.Pane>
                        </Tab.Content>
                      </div>
                    </Tab.Container>
                  </div>
                </Col>
                <Col xl={4} lg={5} className={style.colright}>
                  <div className={style.walletleftaddfunds}>
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="deposits"
                      className="tabContainer"
                    >
                      <div className="tabHeader">
                        <Nav variant="pills" className="navTabs">
                          <Nav.Item>
                            <Nav.Link eventKey="deposits">Deposits</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="withdrawals">
                              Withdrawals
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="convert">Convert</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                      <Tab.Content>
                        <Tab.Pane eventKey="deposits">
                          <Deposit />
                        </Tab.Pane>
                        <Tab.Pane eventKey="withdrawals">
                          <Widthrow />
                        </Tab.Pane>
                        <Tab.Pane eventKey="convert">
                          <Convert onConvertSuccess={getGoldSilverBalances} />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </Col>
              </Row>
            </div>
          </Tab>
        </Tabs>

      </section>
      <Elements stripe={stripePromise} options={options}>
        <StripeCheckoutForm
          show={stripePayModal}
          data={stripeData}
          handleClose={() => setStripePayModal(false)}
          resetForm={formik.resetForm}
        />
      </Elements>
      <PaymentModeModal
        show={payModeModal}
        handleClose={() => setPayModeModal(false)}
        paymentMode={paymentMode}
        setPaymentMode={setPaymentMode}
        handleSubmit={handlePaymentModeSubmit}
        setWalletType={setWalletType}
      />


      <DepositModal
        show={depositModal}
        handleSubmit={handleDepositModal}
        handleClose={() => setDepositModal(false)}
      />
      <AddFunds
        show={addFundModal}
        walletType={paymentMode}
        handleAddFunds={handleAddFunds}
        handleClose={() => setAddFundModal(false)}
      />
      <TransactionHistoryModal
        show={showModal}
        page={fiatWalletPage} // === MINIMUM CHANGE: Use fiatWalletPage ===
        setPage={setFiatWalletPage} // === MINIMUM CHANGE: Use setFiatWalletPage ===
        userLedger={userLedger}
        setSelectedWallet={setSelectedWallet}
        handleClose={() => setShowModal(false)}
      />
      <BankDetailsModal
        show={showBankDetailsModal}
        handleClose={() => setShowBankDetailsModal(false)}
        bankDetails={selectedBankDetails}
      />
    </>
  );
};

export default WalletPortfolio;